import { Base64 } from 'js-base64';

export const base64Encode = function (str) {
  return Base64.encode(str);
};

export const base64Decode = function (str) {
  return Base64.decode(str);
};

/**
 * 判断是否为空，如果是null/undefined、空字符串、空数组、空对象，则认为是空
 * @param {*} value
 * @returns
 */
export const isEmpty = function (value) {
  // 检查null、undefined
  if (value == null) return true;

  // 检查数组、字符串
  if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;

  // 检查对象
  if (typeof value === 'object') return Object.keys(value).length === 0;

  // 不是null/undefined、字符串、数组、对象，则不认为是空
  return false;
};

// const targetId = 5;
// const path = findPath(tree, targetId);
// console.log(path); // 输出的路径将会是 [1, 3, 5]
/**
 * 树中搜索给定的 id,并返回id构建的路径数组
 * @param {*} tree
 * @param {*} id
 * @param {*} path
 * @returns
 */
export const findPath = function (tree, id, path = []) {
  for (const node of tree) {
    // 当前路径添加新节点
    const newPath = path.concat(node.id);

    // 检查当前节点是否是目标节点
    if (node.id == id) {
      return newPath;
    }

    // 如果当前节点有子节点，继续深入搜索
    if (node.children) {
      const result = findPath(node.children, id, newPath);
      if (result) {
        return result; // 如果子节点中找到目标节点，则返回路径
      }
    }
  }

  // 如果没有找到，返回 undefined
  return undefined;
};

/**
 * 截取指定长度额字符串,超过部分用省略号代替
 * @param {String} str
 * @param {Number} maxLength
 * @returns
 */
export const cutString = function (str, maxLength) {
  // 如果当前字符串长度超过了最大长度，则执行截取及添加省略号
  if (str.length > maxLength) {
    // 使用substring方法截取从0到maxLength的部分
    return str.substring(0, maxLength) + '...';
  }

  // 如果长度未超过，直接返回原字符串
  return str;
};
